import { useState, useEffect } from 'react';
import '../styles/TeachingStaff.css';

export default function TeachingStaff() {

     const [isVisible, setIsVisible] = useState(false);
    
      useEffect(() => {
        setIsVisible(true);
      }, []);
    

  const teachingStaffData = [
    { sn: 1, name: "SH.ASHOK GROVER", designation: "PRINCIPAL", qualification: "MA (ENG.,POL SCI)+B.Ed" },
    { sn: 2, name: "SH.SUDESH SHARMA", designation: "TEACHER", qualification: "M SC (MATHEMATICS) +B .Ed" },
    { sn: 3, name: "SMT. RENU BHADU", designation: "TEACHER", qualification: "M A (HINDI)+ B.Ed" },
    { sn: 4, name: "SH.AJAY KUMAR JANDU", designation: "TEACHER", qualification: "M A (GEO.)+ B.Ed" },
    { sn: 5, name: "SMT.MEERA SHARMA", designation: "TEACHER", qualification: "M A (SANSKRIT, HINDI, RAJASTHNI EDU.) + B.Ed" },
    { sn: 6, name: "SMT.ANJANA SAXENA", designation: "TEACHER", qualification: "M A (POL.SCI.) + B.Ed" },
    { sn: 7, name: "SMT.SUMAN RIWAR", designation: "TEACHER", qualification: "M A (SOCIOLOGY ) B.Ed" },
    { sn: 8, name: "SH.BHUPENDER NAGAR", designation: "TEACHER", qualification: "M A (HINDI, PSYCHOLOGY ) , B.Ed, M.PHL" },
    { sn: 9, name: "SMT.AARTI SHARMA", designation: "TEACHER", qualification: "M A (ENGLISH) B.Ed" },
    { sn: 10, name: "SMT.SAVITRI NEWAR", designation: "TEACHER", qualification: "M A (HINDI) B.Ed" },
    { sn: 11, name: "SMT.POOJA WASAN", designation: "TEACHER", qualification: "M COM (ACC, B.ST.) B.Ed" },
    { sn: 12, name: "SH. DHEERAJ KUMAR", designation: "PTI", qualification: "B SC , B.Ed, B.P.Ed" },
    { sn: 13, name: "SMT.RAJNI BALA", designation: "TEACHER", qualification: "M A (HINDI) B.Ed" },
    { sn: 14, name: "SH.TILAK RAJ", designation: "TEACHER", qualification: "M.COM. B.Ed." },
    { sn: 15, name: "SMT.PUSHPA SHARMA", designation: "TEACHER", qualification: "M A (HINDI, HISTORY, ENG. EDUCATION ) B.Ed, M. Ed" },
    { sn: 16, name: "SMT.KANCHAN SWAMI", designation: "TEACHER", qualification: "B A , B.Ed" },
    { sn: 17, name: "SMT.VANDNA TIWARI", designation: "TEACHER", qualification: "B A , B.Ed" },
    { sn: 18, name: "SMT.SONA RANI", designation: "TEACHER", qualification: "M A , B.Ed IN PUNJABI" },
    { sn: 19, name: "SH.MAHESH KUMAR SINGAL", designation: "TEACHER", qualification: "M SC (MATH) B.Ed" },
    { sn: 20, name: "SH.MANOJ SETIA", designation: "TEACHER", qualification: "M SC (CHEM.) B.Ed" },
    { sn: 21, name: "SH.RAJKUMAR NARANG", designation: "TEACHER", qualification: "M SC (MATHS) B.Ed" },
    { sn: 22, name: "SMT.SUMAN NAGAR", designation: "TEACHER", qualification: "M A , B.Ed" },
    { sn: 23, name: "SH.SHILPA KHATRI", designation: "TEACHER", qualification: "M SC (COMPUTERS ) M.C.A" },
    { sn: 24, name: "SH.RAJESH KUMAR", designation: "TEACHER", qualification: "B.Sc. B.Ed." },
    { sn: 25, name: "SMT.RICHA KALANI", designation: "TEACHER", qualification: "M A (SOCIOLOGY) NTT" },
    { sn: 26, name: "SH.BALRAM SHARMA", designation: "TEACHER", qualification: "M SC (ZOOLOGY) B Ed" },
    { sn: 27, name: "SH.GAJANAND CHANDAK", designation: "TEACHER", qualification: "B SC (AG.) B. Ed" },
    { sn: 28, name: "SH.RAKESH KUMAR VERMA", designation: "TEACHER", qualification: "M A (SOCIOLOGY) B.Ed" },
    { sn: 29, name: "SMT.PREETI DHURIA", designation: "TEACHER", qualification: "M A (SOCIOLOGY AND HINDI) B.Ed , NTT" },
    { sn: 30, name: "SMT. SUNITA YOGI", designation: "PTI", qualification: "B A , C.P.Ed" },
    { sn: 31, name: "SH.RAKESH PIDIYAR", designation: "TEACHER", qualification: "M A (GEO) B.Ed, M.PHIL (GEO)" },
    { sn: 32, name: "SH.MAHIPAL RAWAT", designation: "TEACHER", qualification: "B. TECH" },
    { sn: 33, name: "SMT.NEETU", designation: "TEACHER", qualification: "M A (PUNJABI ) B .Ed" },
    { sn: 34, name: "SMT.DIMPLE", designation: "TEACHER", qualification: "M A , B.Ed (M A PUN., HIS.)" },
    { sn: 35, name: "SMT.MAINA DEVI", designation: "TEACHER", qualification: "M A (HINDI ) B.Ed" },
    { sn: 36, name: "SMT. SUNITA BISHNOI", designation: "PTI", qualification: "B A , M A , BSTC, B.PED" },
    { sn: 37, name: "SMT.NISHA GARG", designation: "TEACHER", qualification: "M. COM (ABST, BUSSINESS MANAG) B.Ed" },
    { sn: 38, name: "SMT.TAXILA KHATRI", designation: "TEACHER", qualification: "B.COM, B.Ed, M.COM (BUS.MANG.)" },
    { sn: 39, name: "SMT.NISHA MIDDHA", designation: "TEACHER", qualification: "M A (ENGLISH) , M.SC(COMPUTER SCI), BSTC, B.Ed" },
    { sn: 40, name: "SH. PUNIT VASHISHT", designation: "TEACHER", qualification: "M A , L.LB" },
    { sn: 41, name: "SH.RAJPARKASH", designation: "TEACHER", qualification: "M A (GEO) B.Ed" },
    { sn: 42, name: "SMT.POOJA KHANNA", designation: "TEACHER", qualification: "TRIPLE M A , M.Ed" },
    { sn: 43, name: "SH. ROHIT CHAWLA", designation: "TEACHER", qualification: "B SC , B.Ed" },
    { sn: 44, name: "SMT. RICHA GOYAL", designation: "TEACHER", qualification: "B A (INTER ARTS) B.Ed" },
    { sn: 45, name: "SH. DHANRAJ VERMA", designation: "PTI", qualification: "12TH , B.PED" },
    { sn: 46, name: "SMT.VINOD RANI", designation: "TEACHER", qualification: "B A , NTT" },
    { sn: 47, name: "SH. LABH SINGH", designation: "TEACHER", qualification: "M.A. B.Ed." },
    { sn: 48, name: "SMT. KAJAL", designation: "TEACHER", qualification: "M COM, B.Ed, NET QUALIFY, CET QUALIFY, TET QUALIFY" },
    { sn: 49, name: "SMT. NISHA NARANG", designation: "TEACHER", qualification: "M SC (COMPUTER SCI. ) B.Ed" },
    { sn: 50, name: "SMT. RUCHI BISHT", designation: "TEACHER", qualification: "B. SC (B.ED)" },
    { sn: 51, name: "SMT. JYOTI BHARDWAJ", designation: "TEACHER", qualification: "B. SC (B.ED)" },
    { sn: 52, name: "SMT. KANTA RANI", designation: "TEACHER", qualification: "B A , B.Ed (M A PUNJABI)" },
    { sn: 53, name: "MS. ANCHAL", designation: "TEACHER", qualification: "M.ED EDUCATION" },
    { sn: 54, name: "SH. VIPIN", designation: "TEACHER", qualification: "M A (GEO) B.Ed, NET (GEO)" },
    { sn: 55, name: "SH. MAINPAL", designation: "TEACHER", qualification: "M A (B.Ed)" },
    { sn: 56, name: "SMT.JUHI KATARIA", designation: "TEACHER", qualification: "M.COM. B.Ed., M LIB" }
  ];

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredStaff, setFilteredStaff] = useState(teachingStaffData);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    setCurrentPage(1);
    
    const filtered = teachingStaffData.filter(staff =>
      staff.name.toLowerCase().includes(term) ||
      staff.designation.toLowerCase().includes(term)
    );
    setFilteredStaff(filtered);
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedStaff = filteredStaff.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredStaff.length / itemsPerPage);

  return (

    <>
      {/* Hero Banner with Image */}
      <section className={`sgb-hero-banner ${isVisible ? 'sgb-fade-in' : ''}`}>
        <div className="sgb-hero-overlay">
          <div className="sgb-hero-text-content">
            <h1 className="sgb-hero-main-title">Teaching-Staff</h1>
          </div>
        </div>
      </section>
    <div className="teaching-container">
        
      <div className="teaching-search-box">
        <input
          type="text"
          placeholder="Search by name or designation..."
          value={searchTerm}
          onChange={handleSearch}
          className="teaching-search-field"
          />
        <svg className="teaching-search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M19 19L14.65 14.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>

      <div className="teaching-entries-info">
        <div className="teaching-show-entries">
          Show: 
          <select 
            value={itemsPerPage} 
            onChange={(e) => {
                setItemsPerPage(e.target.value === 'all' ? filteredStaff.length : parseInt(e.target.value));
                setCurrentPage(1);
            }}
            className="teaching-entries-select"
            >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
            <option value="all">All</option>
          </select>
          <span className="teaching-entries-text"> entries</span>
        </div>
        <div className="teaching-showing-info">
          Showing {startIndex + 1} to {Math.min(endIndex, filteredStaff.length)} of {filteredStaff.length} entries
        </div>
      </div>

      <div className="teaching-table-container">
        {filteredStaff.length > 0 ? (
            <table className="teaching-table">
            <thead>
              <tr>
                <th>S. NO.</th>
                <th>NAME OF EMPLOYEE</th>
                <th>DESIGNATION</th>
                <th>QUALIFICATIONS</th>
              </tr>
            </thead>
            <tbody>
              {paginatedStaff.map((staff, index) => (
                  <tr key={index}>
                  <td className="teaching-sn">{staff.sn}</td>
                  <td className="teaching-name">{staff.name}</td>
                  <td className="teaching-designation">
                    <span className="teaching-badge">{staff.designation}</span>
                  </td>
                  <td className="teaching-qualification">{staff.qualification}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
            <div className="teaching-no-results">
            <p>No results found</p>
          </div>
        )}
      </div>

      <div className="teaching-pagination">
        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
            key={page}
            className={`teaching-page-btn ${currentPage === page ? 'active' : ''}`}
            onClick={() => setCurrentPage(page)}
            >
            {page}
          </button>
        ))}
      </div>
    </div>
        </>
  );
}